module.exports = __webpack_public_path__ + "static/hotel-combined-233c6f2eed213332d062bc0ccb37ce0e.png";